import { render, staticRenderFns } from "./DecoItemInventoryModal.vue?vue&type=template&id=65336440&"
import script from "./DecoItemInventoryModal.vue?vue&type=script&lang=ts&"
export * from "./DecoItemInventoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports